import React from 'react'
import { Link } from '../../Link'

export const DocsBreadcrumbBar = ({ title = '' }) => {
  return (
    <section id="breadcrumbs" className="breadcrumbs">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="m-1">{title || 'Docs'}</h3>
          </div>
          <ol>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link reloadDocument to="/docs">
                Docs
              </Link>
            </li>
            {title && <li>{title}</li>}
          </ol>
        </div>
      </div>
    </section>
  )
}
